const styles = {
  postContainer: {
    columnWidth: 500,
    columnGap: 20,
    width: '100vw',
    padding: 20,
  },
  postWrap: {
    display: 'inline-block',
    width: '100%',
    padding: 10,
  },
  post: {
    marginBottom: 20,
  },
  imageWrap: {
    overflow: 'hidden',
    marginBottom: 10,
  },
  thumbnail: {
    height: 'auto',
    width: '100%',
  },
  sfwThumbnail: {
    height: 'auto',
    width: '100%',
    filter: 'blur(30px)',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Posts/styles.js